/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';

import template from './budget-view.component.html';
import {APP_SHARED} from '../common/app-shared';
import {FORM_CONTROLS} from '../common/directives/form-controls/form-controls';

@Component({
  standalone: true,
  imports: [...APP_SHARED, ...FORM_CONTROLS],
  selector: 'adn-budget-view',
  template
})
export class BudgetViewComponent {
  @Input() uiBudgets: any[] = [];
  @Input() budgetRollover = false;
  @Input() budgetResult: any;
  @Input() isNew = false;
  @Output() editBudgets = new EventEmitter<void>();

  onEditBudgets(): void {
    this.editBudgets.emit();
  }
}
